// Config data-driven del panel de marca del login (dominio WAIA, no marca blanca).
// Sumar una mejora de WAIA/TurnosIA = una entrada acá + sus keys i18n en los 4 idiomas.
//
// Cada sección: { id, icon (MUI icon component), titleKey, chipsKeys[] }.
// El componente Login itera este array — v1 renderiza la 1ra como hero y el resto
// como teasers compactos + una nav de labels (sin interacción todavía).

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import EventIcon from "@material-ui/icons/Event";
import ExtensionIcon from "@material-ui/icons/Extension";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

export const LOGIN_PANEL_SECTIONS = [
  {
    id: "waia",
    icon: WhatsAppIcon,
    titleKey: "loginPage.sections.waia.title",
    chipsKeys: [
      "loginPage.sections.waia.chip1",
      "loginPage.sections.waia.chip2",
      "loginPage.sections.waia.chip3",
    ],
  },
  {
    id: "turnosia",
    icon: EventIcon,
    titleKey: "loginPage.sections.turnosia.title",
    chipsKeys: [
      "loginPage.sections.turnosia.chip1",
      "loginPage.sections.turnosia.chip2",
      "loginPage.sections.turnosia.chip3",
    ],
  },
  {
    id: "integraciones",
    icon: ExtensionIcon,
    titleKey: "loginPage.sections.integraciones.title",
    chipsKeys: [
      "loginPage.sections.integraciones.chip1",
      "loginPage.sections.integraciones.chip2",
      "loginPage.sections.integraciones.chip3",
      "loginPage.sections.integraciones.chip4",
    ],
  },
];

// Badge fijo (no rota) al pie del panel de marca.
export const LOGIN_META_BADGE = {
  icon: VerifiedUserIcon,
  textKey: "loginPage.metaBadge",
};
